<template>
    <v-row class="pb-4">
        <v-col cols="12" class="text-body-2 d-flex justify-space-between align-center">
            Commandes
        </v-col>
        <v-col>
          <v-data-table
              :headers="headers"
              :items="items"
              disable-pagination
              class="elevation-1"
              hide-default-header
              hide-default-footer
              @click:row="handleClick"
              dense
          >
            <template v-slot:item.statusId="{item}">
              <v-chip small outlined :color="statusColor(item.statusId)" dark>
                {{ item.statusId}}
              </v-chip>
            </template>

            <template v-slot:item.price="{item}">
                {{ item.price | currency(item.currency)}}
            </template>
          </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import currency from "../forms/select/Currency.vue";

export default {
  computed: {
    currency() {
      return currency
    }
  },
  data: () => {
    return {
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Status',
          value: 'statusId',
        },
        {
          text: 'Status',
          value: 'client.displayName',
        },
        {
          text: 'Status',
          value: 'price',
        },
        {
          text: 'Status',
          value: 'invoice.invoiceNumber',
        },
      ]
    }
  },
    props:{
        items:{
            type: Array,
            required:true
        },
        type: {
            type: String,
            default: () => 'all'
        }
    },
    methods:{
        open(id){
            this.$router.push('/orders/view/'+id);
            this.$emit('close')
        },

      handleClick(item) {
        this.open(item.id)
      },
      statusColor(status){

        const colors = {
          new: 'default',
          open: 'warning',
          close: 'success',
          cancel: 'error'
        }

        return colors[status] || 'default'

      }
    }
}
</script>